import { adminInstance } from "@/api/instance";

export default async function (b4aId, data) {
  return adminInstance.put(`/b4a/${b4aId}`, data);
}
